import gql from "graphql-tag";
import { UserFragment, EmailFragment, PhoneFragment } from "./fragments";
import { createBoundMutation } from "./util";
import { MutationUpdaterFn } from "apollo-client";
import { Query } from "types";
import { getAppData } from "./query";
import _ from "lodash";

const addEmail = gql`
mutation addEmail($email:String){
  addEmail(email: $email){
    ...UserFragment,
    emails{
      ...EmailFragment
    }
  }
},
${UserFragment},
${EmailFragment}
`;

const confirmEmail = gql`
  mutation confirmEmail($id: String, $code: String) {
    confirmEmail(id: $id, code: $code) {
      ...EmailFragment
    }
  }
  ${EmailFragment}
`;

const addPhone = gql`
mutation addPhone($phone:String){
  addPhone(phone_number: $phone){
    ...UserFragment,
    phones{
      ...PhoneFragment
    }
  }
},
  ${UserFragment},
  ${PhoneFragment}
`;

const confirmPhone = gql`
  mutation confirmPhone($id: String, $code: String) {
    confirmPhone(id: $id, code: $code) {
      ...PhoneFragment
    }
  }
  ${PhoneFragment}
`;

export const editUser = gql`
  mutation editUser(
    $type: String
    $name: String
    $address: String
    $uniqueId: String
  ) {
    editUser(
      type: $type
      name: $name
      address: $address
      unique_identifier: $uniqueId
    ) {
      id
      type
      name
      address
      unique_identifier
    }
  }
`;

const contact = gql`
  mutation contact(
    $name: String
    $email: String
    $phone: String
    $message: String
  ) {
    contact(name: $name, email: $email, phone: $phone, message: $message)
  }
`;

const deletePhone = gql`
  mutation deletePhone(
    $id: String

  ) {
    deletePhone(id: $id)
  }
`;

const deleteEmail = gql`
  mutation deleteEmail(
    $id: String

  ) {
    deleteEmail(id: $id)
  }
`;

export namespace userMutations {
  export interface AddEmailArgs {
    email: string;
  }
  export const AddEmail = createBoundMutation<void, AddEmailArgs>({
    mutation: addEmail
  });

  export const ConfirmPhone = createBoundMutation<void, ConfirmContactArgs>({
    mutation: confirmPhone
  });

  interface EditUserArgs {
    type: string;
    name: string;
    address: string;
    uniqueId: string;
  }

  export const EditUser = createBoundMutation<any, EditUserArgs>({
    mutation: editUser
  });

  export interface ConfirmContactArgs {
    id: string;
    code: string;
  }

  export const ConfirmEmail = createBoundMutation<void, ConfirmContactArgs>({
    mutation: confirmEmail
  });

  export interface AddPhoneArgs {
    phone: string;
  }

  export const AddPhone = createBoundMutation<void, AddPhoneArgs>({
    mutation: addPhone
  });

  export interface ContactArgs {
    name?: string;
    email?: string;
    phone?: string;
    message: string;
  }

  export const Contact = createBoundMutation<void, ContactArgs>({
    mutation: contact
  });

  const contactDeleteUpdaterFn = (cacheKey: "phones" | "emails") => {
    const updater: MutationUpdaterFn = (proxy, res) => {
      const query = proxy.readQuery<Query>({
        query: getAppData
      });
      const entity = Object.entries(res.data)[0][1] as any;
      proxy.writeQuery({
        query: getAppData,
        data: {
          ...query,
          currentUser: {
            ...query.currentUser,
            [cacheKey]: _.filter(query.currentUser[cacheKey], (c: any) => c.id !== entity),
          }
        }
      });

    };
    return updater;

  };

  export interface DeletePhoneArgs {
    id?: string;
  }

  export const DeletePhone = createBoundMutation<any, DeletePhoneArgs>({
    mutation: deletePhone,
    update: contactDeleteUpdaterFn("phones")
  });

  export interface DeleteEmailArgs {
    id?: string;
  }

  export const DeleteEmail = createBoundMutation<any, DeleteEmailArgs>({
    mutation: deleteEmail,
    update: contactDeleteUpdaterFn("emails")
  });

}



// WEBPACK FOOTER //
// ./src/api/user.ts